/**
 * index.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from '@sohonet/ui-components/themes';
import { createBrowserHistory } from 'history';
import AuthProvider from 'components/AuthProvider/AuthProvider';
import ServiceBootstrapper from 'components/ServiceBootstrapper/ServiceBootstrapper';

import '@sohonet/ui-components/fontDeclarations.css';
import 'sanitize.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import * as serviceWorker from 'utils/serviceWorker';
import configureStore from 'utils/configureStore';
import App from 'app';

// Global CSS
import GlobalStyles from 'css/globalStyles';

import { MOUNT_NODE } from 'utils/constants';

// This webpack variable applies a nonce to all script tags
// TODO: get it from .env
__webpack_nonce__ = 'c29tZSBjb29sIHN0cmluZyB3aWxsIHBvcCB1cCAxMjM='; // eslint-disable-line no-undef

const history = createBrowserHistory();
const initialState = {};
const store = configureStore(initialState, history);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      <ConnectedRouter history={history}>
        <AuthProvider>
          <ServiceBootstrapper>
            <App />
          </ServiceBootstrapper>
        </AuthProvider>
      </ConnectedRouter>
    </ThemeProvider>
  </Provider>,
  MOUNT_NODE
);

// https://facebook.github.io/create-react-app/docs/making-a-progressive-web-app
serviceWorker.unregister();
